import React from 'react'

const Footer = () => {
  return (
    <footer>
    <div>
        <h1>shivdev .</h1>
        <p>@All rights reserved</p>
    </div>

    <div>
        <h5>Follow Us</h5>
        <div>
            <a href="https://youtube.com" target='blank'>YouTube</a>
            <a href="https://google.com" target='blank'>Google</a>
            <a href="https://instagram.com" target='blank'>Instagram</a>
            <a href="https://facebook.com" target='blank'>Facebook</a>
        </div>
    </div>
    </footer>
  )
}

export default Footer
